import { useAccountCompanyId } from 'application/hooks';

import useVideoMeiafiles from '@entities/company/api/useCompanyMediafiles';

export const useVideoMediafiesPresenter = (query?: string) => {
  const companyId = useAccountCompanyId();

  const {
    companyMediafiles,
    refetch,
    loading,
    getMoreCompanyMediafiles,
    companyMediafilesPaginationInfo: paginationInfo,
  } = useVideoMeiafiles(companyId, query);

  return {
    videoMediafiles: companyMediafiles || undefined,
    loading,
    refetch,
    loadMore: getMoreCompanyMediafiles,
    companyId,
    paginationInfo,
  };
};
